const WORDS = ["Rooted in tradition", "Reimagined for royalty", "Worn with pride", "Velvet & gold", "For today’s woman"];

const Row = () => (
  <div className="flex shrink-0">
    {[...WORDS, ...WORDS].map((w, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-8 font-display text-4xl font-light sm:text-6xl ${i % 2 ? "italic text-white" : "text-cream"}`}>{w}</span>
        <span className="text-2xl text-white">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-hidden="true" className="overflow-hidden border-y border-gold/20 bg-ink2 py-8">
    <div className="marquee-track flex w-max whitespace-nowrap">
      <Row />
      <Row />
    </div>
  </section>
);
